var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zlr-menu-row"},[_c('ul',_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,class:[_vm.$route.matched.some(function (ref) {
	var name = ref.name;

	return item.name.includes(name);
})?'active':'']},[_c('a',{on:{"click":function($event){return _vm.routerHandle(item.name[0])}}},[_vm._v(_vm._s(item.title))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index !== _vm.menuList.length-1),expression:"index !== menuList.length-1"}],staticClass:"slash"},[_vm._v("/")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }